import React from 'react';
import {
  Play, Plus, ThumbsUp, Share2, Headphones,
  BookOpen as BookOpenIcon, BookmarkCheck, ExternalLink, Code2,
} from 'lucide-react';
import { Button } from '../ui/button';

const HeroActions = ({
  book,
  hasTrailer,
  inMyList,
  liked,
  onReadBook,
  onListenAudiobook,
  onAddToList,
  onLike,
  onShare,
  onEmbed,
}) => {
  const hasAudio = book.audiobook_file_url || book.audiobook_chapters?.length > 0;
  return (
    <>
      <div className="flex flex-wrap items-center gap-4 pt-4">
        <Button
          size="lg"
          onClick={onReadBook}
          className="bg-white text-black hover:bg-white/90 font-semibold px-8 py-6 text-lg transition-transform hover:scale-105"
          data-testid="read-book-btn"
        >
          <BookOpenIcon className="mr-2 h-6 w-6" />
          Read Full Book
        </Button>
        {hasTrailer && (
          <Button
            size="lg"
            onClick={() => document.getElementById('trailer-section')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-red-600 text-white hover:bg-red-700 font-semibold px-8 py-6 text-lg transition-transform hover:scale-105"
            data-testid="trailer-preview-btn"
          >
            <Play className="mr-2 h-6 w-6" />
            Book Trailer Preview
          </Button>
        )}
        {hasAudio && (
          <Button
            size="lg"
            onClick={onListenAudiobook}
            className="bg-purple-600 text-white hover:bg-purple-700 font-semibold px-8 py-6 text-lg transition-transform hover:scale-105"
            data-testid="listen-audiobook-btn"
          >
            <Headphones className="mr-2 h-6 w-6" />
            Listen Audiobook
          </Button>
        )}
        <Button
          size="lg"
          variant="secondary"
          onClick={onAddToList}
          className={`backdrop-blur-sm font-semibold px-8 py-6 text-lg border transition-transform hover:scale-105 cursor-pointer ${
            inMyList
              ? 'bg-green-600/30 text-green-400 border-green-500/50 hover:bg-green-600/40'
              : 'bg-white/20 text-white border-white/30 hover:bg-white/30'
          }`}
          data-testid="my-list-btn"
        >
          {inMyList ? <BookmarkCheck className="mr-2 h-6 w-6" /> : <Plus className="mr-2 h-6 w-6" />}
          {inMyList ? 'In My List' : 'My List'}
        </Button>
        <Button
          size="icon"
          variant="ghost"
          onClick={onLike}
          className={`h-12 w-12 rounded-full border-2 transition-all cursor-pointer ${
            liked
              ? 'border-blue-400 text-blue-400 bg-blue-500/20 hover:bg-blue-500/30'
              : 'border-white/40 text-white hover:border-white hover:bg-white/20'
          }`}
          data-testid="like-btn"
        >
          <ThumbsUp className={`h-6 w-6 ${liked ? 'fill-current' : ''}`} />
        </Button>
        <Button
          size="icon"
          variant="ghost"
          onClick={onShare}
          className="h-12 w-12 rounded-full border-2 border-white/40 text-white hover:border-white hover:bg-white/20 cursor-pointer"
          data-testid="share-btn"
        >
          <Share2 className="h-6 w-6" />
        </Button>
        {onEmbed && (
          <Button
            size="icon"
            variant="ghost"
            onClick={onEmbed}
            title="Embed this book on a website"
            className="h-12 w-12 rounded-full border-2 border-white/40 text-white hover:border-white hover:bg-white/20 cursor-pointer"
            data-testid="book-embed-btn"
          >
            <Code2 className="h-6 w-6" />
          </Button>
        )}
      </div>

      {(book?.amazon_link || book?.barnes_noble_link || book?.author_website_link) && (
        <div className="flex flex-wrap gap-3 mt-4" data-testid="purchase-links">
          {book.amazon_link && (
            <a
              href={book.amazon_link}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white text-sm font-medium rounded-lg transition-colors"
              data-testid="amazon-link"
            >
              <ExternalLink className="h-4 w-4" />Buy on Amazon
            </a>
          )}
          {book.barnes_noble_link && (
            <a
              href={book.barnes_noble_link}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-medium rounded-lg transition-colors"
              data-testid="barnes-noble-link"
            >
              <ExternalLink className="h-4 w-4" />Barnes & Noble
            </a>
          )}
          {book.author_website_link && (
            <a
              href={book.author_website_link}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors"
              data-testid="author-website-link"
            >
              <ExternalLink className="h-4 w-4" />Author's Website
            </a>
          )}
        </div>
      )}
    </>
  );
};

export default HeroActions;
